import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_18: FaireProductEntity = {
  token: "toysmith-18",
  type: "product",
  name: "Water Bazooka, Assorted Colors",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/593ef3ae6a34d8a8519ebbdb7317280118e5804e0544f3c76032c1acafad95fa.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 11,
  msrpDollars: 22,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
